import { 
  EpDevPPluginIds
} from '../../constants';
import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPHealthApiClient,
  IEpDevPHealthResponse,
  IEpDevPPluginHealthCreate,
  IEpDevPPluginHealthResponse,
} from '../types';
import { 
  EpDevPHealthApiPathsFactory
} from './EpDevPHealthApiFactories';



export class EpDevPHealthApiClient extends EpDevPApiClient implements IEpDevPHealthApiClient {

  public async getHealth({ includeDetails }:{
    includeDetails: boolean;
  }): Promise<IEpDevPHealthResponse> {
    const epDevPHealthResponse: IEpDevPHealthResponse = await this.request({
      method: 'GET',      
      url: await this.createUrl(EpDevPHealthApiPathsFactory.createGetHealthPath({
        includeDetails: includeDetails
      }))
    });    
    return epDevPHealthResponse;
  }

  public async getPluginHealth({ pluginId, includeDetails }:{
    pluginId: EpDevPPluginIds;
    includeDetails: boolean;
  }): Promise<IEpDevPPluginHealthResponse> {
    const epDevPPluginHealthResponse: IEpDevPPluginHealthResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPHealthApiPathsFactory.createGetPluginHealthPath({
        pluginId: pluginId,
        includeDetails: includeDetails
      })),
    });
    return epDevPPluginHealthResponse;
  }

  public async setPluginHealth({ pluginId, epDevPPluginHealthCreate }:{
    pluginId: EpDevPPluginIds;
    epDevPPluginHealthCreate: IEpDevPPluginHealthCreate;
  }): Promise<void> {
    await this.request({
      method: 'POST',
      url: await this.createUrl(EpDevPHealthApiPathsFactory.createSetPluginHealthPath({
        pluginId: pluginId,
      })),
      body: JSON.stringify(epDevPPluginHealthCreate)
    });
  }

}
